<script lang="ts">
	import { page } from '$app/stores';
	import { deviceWidth } from '$lib/stores';
	import { mobileBreakPoint } from '$lib/utils/constants';
	import { AppRail, AppRailAnchor, drawerStore } from '@skeletonlabs/skeleton';
	import { BuildingStorefrontS, CreditCardS, DocumentTextS, HomeS, TagS, TruckS, UserS } from '@svg';

	const sections = [
		{ onlyMobile: true, icon: HomeS, href: '/', title: 'Página principal', name: 'Inicio' },
		{ onlyMobile: true, icon: TagS, href: '/categorias', title: 'Todas las categorías', name: 'Categorías' },
		{ onlyMobile: true, icon: BuildingStorefrontS, href: '/nosotros', title: 'Sobre Arbatel', name: 'Nosotros' },
		{ onlyMobile: false, icon: UserS, href: '/cuenta', title: '', name: 'Cuenta' },
		{
			onlyMobile: false,
			icon: TruckS,
			href: '/cuenta/direcciones',
			title: 'Direcciones guardadas',
			name: 'Direcciones'
		},
		{
			onlyMobile: false,
			icon: CreditCardS,
			href: '/cuenta/tarjetas',
			title: 'Métodos de pago',
			name: 'Tarjetas'
		},
		{ onlyMobile: false, icon: DocumentTextS, href: '/cuenta/pedidos', title: 'Historial de pedidos', name: 'Pedidos' }
	];
</script>

<AppRail class={$$props.class}>
	{#each sections as { icon, href, title, name, onlyMobile }}
		{#if (onlyMobile && $deviceWidth <= mobileBreakPoint) || !onlyMobile}
			<AppRailAnchor
				{href}
				{title}
				selected={href !== '/cuenta' && href !== '/'
					? $page.url.pathname.startsWith(href)
					: href === $page.url.pathname}
				on:click={drawerStore.close}
			>
				<svelte:fragment slot="lead">
					<svelte:component this={icon} class="w-8" />
				</svelte:fragment>
				<span>{name}</span>
			</AppRailAnchor>
		{/if}
	{/each}
</AppRail>
